module.exports = __webpack_public_path__ + "img/boardLoss.63e6ab09.jpg";